import { Model } from './Model';
import { Student } from './Student';

export default interface Enrollment extends Model {
  id: number;
  klassId: number;
  student: Student;
  status: EnrollmentStatusEnum;
  activatedAt: string | null;
}

export enum EnrollmentStatusEnum {
  ACTIVE = 'ACTIVE',
  AWAITING_CLASS = 'AWAITING_CLASS',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  COURSE_TRANSFERRED = 'COURSE_TRANSFERRED',
  CLASS_TRANSFERRED = 'CLASS_TRANSFERRED',
  CONCLUDED = 'CONCLUDED',
  CANCELED = 'CANCELED',
}

export enum TrialEnrollmentStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  UNQUALIFIED = 'UNQUALIFIED',
  CONCLUDED = 'CONCLUDED',
  OVERDUE = 'OVERDUE',
}
